
import { createReducer } from '@reduxjs/toolkit';
import { INotificationState } from './types';
import { fetchNotifications, markNotificationAsRead, deleteNotification, markAllNotificationsAsRead } from './actions';

const initialState: INotificationState = {
  notifications: [],
  unreadCount: 0,
  loading: false,
  error: null,
  count: 0,
  next: null,
  previous: null,
};

export const notificationsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(fetchNotifications.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchNotifications.fulfilled, (state, action) => {
      state.loading = false;
      const { page, page_size } = action.meta.arg;
      const startIndex = (page - 1) * page_size;

      // Safety check: ensure we have an array
      if (!state.notifications) state.notifications = [];

      if (page === 1 && state.notifications.length === 0) {
        state.notifications = action.payload.results;
      } else {
        state.notifications.splice(startIndex, page_size, ...action.payload.results);
      }

      state.unreadCount = action.payload.unread_count;
      state.count = action.payload.count;
      state.next = action.payload.next;
      state.previous = action.payload.previous;
    })
    .addCase(fetchNotifications.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    })
    .addCase(markNotificationAsRead.fulfilled, (state, action) => {
      const notification = state.notifications.find(n => n.notification_id === action.payload.notificationId);
      if (notification && !notification.is_read) {
        notification.is_read = true;
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
    })
    .addCase(deleteNotification.fulfilled, (state, action) => {
      const notificationIndex = state.notifications.findIndex(n => n.notification_id === action.payload.notificationId);
      if (notificationIndex !== -1) {
        const notification = state.notifications[notificationIndex];
        if (!notification.is_read) {
          state.unreadCount = Math.max(0, state.unreadCount - 1);
        }
        state.notifications.splice(notificationIndex, 1);
        state.count = Math.max(0, state.count - 1);
      }
    })
    .addCase(markAllNotificationsAsRead.fulfilled, (state) => {
      state.notifications.forEach(n => {
        n.is_read = true;
      });
      state.unreadCount = 0;
    });
});
